import React from "react";

function Skills() {
  const skillCategories = [
    {
      label: "Frontend",
      color: "purple",
      skills: ["Next.js", "React", "TypeScript", "JavaScript", "Tailwind CSS", "Vue.js", "HTML/CSS"],
    },
    {
      label: "Backend",
      color: "blue",
      skills: [".NET Core", "C#", "Web API", "RESTful API", "SQL", "Firebase"],
    },
    {
      label: "Mobile",
      color: "indigo",
      skills: ["React Native", "Expo", "Java", "iOS Development", "Android Development"],
    },
    {
      label: "Tools & Other",
      color: "violet",
      skills: ["Git", "Jira", "Agile/Scrum", "Trello", "Unity"],
    },
  ];

  const colorMap = {
    purple: "bg-purple-100 dark:bg-purple-900/40 text-purple-700 dark:text-purple-300 border border-purple-200 dark:border-purple-700",
    blue: "bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-700",
    indigo: "bg-indigo-100 dark:bg-indigo-900/40 text-indigo-700 dark:text-indigo-300 border border-indigo-200 dark:border-indigo-700",
    violet: "bg-violet-100 dark:bg-violet-900/40 text-violet-700 dark:text-violet-300 border border-violet-200 dark:border-violet-700",
  };

  const headerColorMap = {
    purple: "text-purple-600 dark:text-purple-400",
    blue: "text-blue-600 dark:text-blue-400",
    indigo: "text-indigo-600 dark:text-indigo-400",
    violet: "text-violet-600 dark:text-violet-400",
  };

  return (
    <section
      id="skills"
      className="py-16 text-gray-600 dark:text-gray-300 px-10"
    >
      <h2 className="text-4xl text-center mb-8 text-gray-700 dark:text-gray-200">
        Skills
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {skillCategories.map((category) => (
          <div key={category.label}>
            <h3 className={`text-sm font-semibold uppercase tracking-widest mb-4 ${headerColorMap[category.color]}`}>
              {category.label}
            </h3>
            <div className="flex flex-wrap gap-2">
              {category.skills.map((skill) => (
                <span
                  key={skill}
                  className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-200 hover:scale-105 ${colorMap[category.color]}`}
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
